<template>
  <v-app>
    <div class="full-page">
      <v-row no-gutters>
        <!-- الجزء الأيسر -->
        <v-col cols="12" md="6" class="left-panel">

          <div class="login-container">
            <v-card class="login-card">
              <v-card-title class="justify-center">
                <v-icon color="primary" size="48">mdi-account-circle</v-icon>
                <span class="ml-3">تسجيل الدخول</span>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-form fast-fail @submit.prevent="submit" class="my-5">
                  <v-text-field v-model="user.loginName" label="اسم المستخدم" required outlined></v-text-field>
                  <v-text-field v-model="user.password" label="كلمة المرور"
                    :append-icon="isPasswordVisible ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="isPasswordVisible ? 'text' : 'password'"
                    @click:append="isPasswordVisible = !isPasswordVisible" required outlined></v-text-field>
                  <v-btn color="primary" class="mt-4" block type="submit">
                    تسجيل الدخول
                  </v-btn>
                </v-form>
              </v-card-text>
              <!-- <v-card-actions class="justify-center">
                  <v-btn text small color="secondary" @click="forgotPassword">
                    نسيت كلمة المرور؟
                  </v-btn>
                </v-card-actions> -->
            </v-card>
          </div>
        </v-col>

        <!-- الجزء الأيمن -->
        <v-col cols="12" md="6" class="right-panel">
          <div class="content">
            <v-img src="@/assets/clinic-logo-transparent.png" width="500" alt="Clinic Logo" contain
              class="mb-5"></v-img>
            <!-- <h1 class=" font-weight-bold title">
                مرحبًا بك في نظام إدارة نواة كلينك
              </h1> -->
            <!-- <p class="text-subtitle-1 white--text">
                إدارة بيانات المرضى والخدمات بسهولة وأمان.
              </p> -->
          </div>
        </v-col>
      </v-row>
    </div>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      isPasswordVisible: false,

      user: {
        loginName: null,
        password: null,
      },

    };
  },
  methods: {
    submit() {
            if (this.user.loginName != null && this.user.password != null) {
                this.$store
                    .dispatch("security/login", this.user)
                    .then(() => {
                        this.$router.push({ name: "Layout" });
                    })
                    .catch(() => { });
            }
        },
 
  },
};
</script>

<style scoped>
/* ضمان أن التصميم يغطي كامل الشاشة */
.full-page {
  font-family: "Almarai";

  height: 100vh;
  display: flex;
  flex-direction: column;
}

.left-panel,
.right-panel {
  height: 100%;
  /* جعل الجزء يغطي الشاشة بالكامل */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.left-panel {

  background: white;
}

.right-panel {
  background: #83c78313;
  /* اللون الرئيسي */
  color: white;
  box-shadow: 0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12);
}

.title {
  color: #143842 !important;
}

.login-container {
  width: 100%;
  max-width: 400px;
  padding: 20px;
}

.login-card {
  width: 100% !important;
}

.v-btn.primary {
  background-color: #83c783 !important;
  color: white !important;
}

.v-btn.primary:hover {
  background-color: #6fb96f !important;
  /* لون أغمق قليلاً عند التمرير */
}

.v-icon {
  color: #83c783 !important;
}

@font-face {
  font-family: "Almarai";
  src: url("../assets/fonts/Cairo-Medium.ttf") format("truetype");
}

.v-card {
  box-shadow: none;
}

.v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: none;

}
</style>